import axiosInstance from "../../../helper/interceptor";

export const getAllIrrigationAreas = async (params = {}) => {
  try {
    const response = await axiosInstance.get("areas", {
      params: { fields: "id,name,project_id", ...params },
    });
    return response.data;
  } catch (error) {
    if (error?.response?.status === 400) {
      const response = await axiosInstance.get("areas", { params });
      return response.data;
    }
    throw error;
  }
};
export const getIrrigationArea = async (id) => {
  let response = await axiosInstance.get(`areas/${id}`);
  return response.data;
};
export const createIrrigationArea = async (formData) => {
  let response = await axiosInstance.post("areas/", formData);
  return response.data;
};

export const updateIrrigationArea = async (form) => {
  let data = form.formData;
  let response = await axiosInstance.patch(`areas/${form.id}/`, data);
  return response.data;
};
export const updateSingleIrrigationArea = async (form) => {
  let data = form.formData;
  let response = await axiosInstance.patch(`/areas-single-tree/${form.id}/`, data);
  return response.data;
};

export const deleteArea = async (id) => {
  const response = await axiosInstance.delete(`areas/${id}`);
  return response;
};
